module.exports = __webpack_public_path__ + "static/img/logo.db5b4ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = eOq7
// module chunks = 6